import { render, staticRenderFns } from "./ManagerMenuList.vue?vue&type=template&id=1ba127bc&"
import script from "./ManagerMenuList.vue?vue&type=script&lang=js&"
export * from "./ManagerMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports